import axios from 'axios';
import config from '../config';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { useState } from 'react';

export function useStudentDetails() {
  const { studentId } = useParams();
  const [canSeeDetails, setCanSeeDetails] = useState(true);

  const { data, refetch, isLoading } = useQuery(
    ['student', studentId],
    async () => {
      const studentData = new FormData();
      studentData.append('mode', 'getStudentById');
      studentData.append('studentId', studentId);
      studentData.append('auth', localStorage.getItem('token'));
      const output = await axios.post(config.STUDENTS_API, studentData);
      if (output.data.response.status === 'OK') {
        return output.data.response.studentData;
      } else {
        setCanSeeDetails(false);
        return null;
      }
    }
  );

  return { data, refetch, isLoading, canSeeDetails };
}
